export const customButtonStyles = `
  .custom-awesome-button {
    --button-default-height: 60px;
    --button-default-border-radius: 14px;
    --button-horizontal-padding: 60px;
    --button-raise-level: 10px;
    --button-hover-pressure: 2;
    --transform-speed: 0.185s;
    --button-primary-color: #d4dc64;
    --button-primary-color-dark: #aab328;
    --button-primary-color-hover: #aab328;
    --button-primary-border: none;
  }
`;
